import { useMutation, useQueryClient } from '@tanstack/react-query';
import { aiAgentApi } from '@/lib/api';

export function useAiReview() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (submissionId: string) => aiAgentApi.review(submissionId),
    onSuccess: (_data, submissionId) => {
      qc.invalidateQueries({ queryKey: ['formSubmissions'] });
      qc.invalidateQueries({ queryKey: ['formSubmissions', submissionId] });
    },
  });
}

export function useAiFollowUp() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (submissionId: string) => aiAgentApi.sendFollowUp(submissionId),
    onSuccess: (_data, submissionId) => {
      qc.invalidateQueries({ queryKey: ['formSubmissions'] });
      qc.invalidateQueries({ queryKey: ['formSubmissions', submissionId] });
    },
  });
}
